import { Component } from "react";
import styled from "styled-components/macro";
import { copyToClipboard } from "../utils/copyToClipboard";
import { Button } from "antd";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 16px);
  font-family: Inter, sans-serif;
  line-height: 1.5em;
`;

const Inner = styled.div`
  max-width: 600px;
  font-size: 20px;
  text-align: center;
  margin: 30px;
`;

const Error = styled.pre`
  height: 100px;
  overflow: auto;
  margin: 0 30px;
  font-family: monospace;
  max-width: 90%;
`;
const ButtonsContainer = styled.div`
  margin-bottom: 16px;
  display: flex;
  gap: 16px;
`;

class GlobalErrorHandler extends Component {
  state = { hasError: false, errorText: "", expandError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // some logic for logging error could be here

    this.setState({
      errorText:
        error.message + "\n" + error.stack + "\n" + errorInfo.componentStack
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Root>
          {/* Set text without translation cause l18n service could not be available at the moment */}
          <Inner>
            Oops, there is a problem with your browser or our app. Don't worry!
            Try opening you browser in incognito mode and logging in again. If
            the problem persists, please get in touch with us via contact{" "}
            <a href="http://localhost:3009/gb/contact?f=f">form</a>.
          </Inner>
          <ButtonsContainer>
            <Button
              onClick={() => {
                copyToClipboard(this.state.errorText);
              }}
              size={"large"}
              type="primary"
            >
              Copy error details
            </Button>
            <Button
              onClick={() => {
                this.setState({
                  expandError: !this.state.expandError
                });
              }}
              size={"large"}
            >
              {this.state.expandError
                ? "Hide error details"
                : "Show error details"}
            </Button>
          </ButtonsContainer>
          {this.state.expandError ? (
            <Error>{this.state.errorText}</Error>
          ) : null}
        </Root>
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorHandler;
